<template lang="pug">
#docContainer(v-loading='loading' element-loading-text='图片加载中...' element-loading-background='rgba(0, 0, 0, 0.5)')
  .viewerDom(ref="image")
    img( ref="bigImage" :src='imageUrl')
  application(ref='docApplication' type="image" v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo, addWaterMarker, clearWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/appView/applicationH5.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  components: { application },
  data() {
    return {
      inputText: "",
      loading: true,
      imageUrl: '',
      docloaded: false
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created () {
    this.getFileInfo();
  },
  beforeDestroy(){
    clearWaterMarker(document.body);
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await mongeApiMlib.initEvent();
      await this.getRequestData(sharerId);
    },
    getRequestData(sharerId) {
      const otherData = this.docmentData;
      this.imageUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      addWaterMarker(document.body, creatWatermarkUserInfo());
      this.loading = false;
      this.docloaded = true;
    }
  }

};
</script>
<style lang="scss" scoped>
#docContainer{
  width: 100vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  .viewerDom{
    width: 100%;
    height: 100%;
    padding-top: 44px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    img{
      width: 100%;
    }
  }
  .viewerDom::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .imageLoading{
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
